import styled from 'styled-components';

export const WarningWrapper = styled.div`
  padding: 0.3rem 0.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background-color: ${({ theme }) => theme.colors.surface.rejectedBackground};
  width: fit-content;
  margin-bottom: 0.2rem;
`;
